function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PALETTE_DATA = {
  light: {
    color: 'grey.300',
    hover: 'grey.500',
    ghostHover: 'grey.200',
    disabled: 'grey.200'
  },
  neutral: {
    color: 'grey.700',
    hover: 'grey.800',
    ghostHover: 'grey.200',
    disabled: 'grey.300'
  },
  primary: {
    color: 'blue.500',
    hover: 'blue.600',
    ghostHover: 'blue.100',
    disabled: 'blue.300'
  },
  danger: {
    color: 'red.500',
    hover: 'red.600',
    ghostHover: 'red.100',
    disabled: 'red.300'
  },
  success: {
    color: 'green.500',
    hover: 'green.600',
    ghostHover: 'green.100',
    disabled: 'green.300'
  }
};

var focusOutlineStyle = function focusOutlineStyle() {
  return {
    boxShadow: 'focus'
  };
};

var getSolidColorStyles = function getSolidColorStyles(props) {
  var paletteData = PALETTE_DATA[props.palette];
  var backgroundColor = paletteData.color,
      hover = paletteData.hover,
      disabled = paletteData.disabled;
  return {
    color: 'white',
    // text color
    backgroundColor: backgroundColor,
    '&:hover': {
      backgroundColor: hover
    },
    '&.focus-visible': focusOutlineStyle(),
    '&[disabled]': {
      backgroundColor: disabled
    }
  };
};

var getOutlineColorStyles = function getOutlineColorStyles(props) {
  var paletteData = PALETTE_DATA[props.palette];
  var color = paletteData.color,
      hover = paletteData.hover,
      disabled = paletteData.disabled;
  return {
    color: color,
    borderColor: color,
    backgroundColor: 'transparent',
    '&:hover': {
      borderColor: hover,
      color: hover
    },
    '&.focus-visible': _objectSpread(_objectSpread({}, focusOutlineStyle()), {}, {
      color: hover,
      borderColor: hover
    }),
    '&[disabled]': {
      borderColor: disabled,
      color: disabled
    }
  };
};

var getGhostColorStyles = function getGhostColorStyles(props) {
  var paletteData = PALETTE_DATA[props.palette];
  var color = paletteData.color,
      hover = paletteData.hover,
      ghostHover = paletteData.ghostHover,
      disabled = paletteData.disabled;
  return {
    color: color,
    backgroundColor: 'transparent',
    '&:hover': {
      color: hover,
      backgroundColor: ghostHover,
      borderColor: ghostHover // keep borderColor same as bg (for size)

    },
    '&.focus-visible': _objectSpread(_objectSpread({}, focusOutlineStyle()), {}, {
      color: hover // keep borderColor same as bg (for size)

    }),
    '&[disabled]': {
      color: disabled,
      // reset background & border for disabled
      backgroundColor: 'transparent',
      borderColor: 'transparent'
    }
  };
};

var getIconColorStyles = function getIconColorStyles(props) {
  return getGhostColorStyles(props);
};

var solidAppearance = function solidAppearance(props) {
  var colorStyles = getSolidColorStyles(props);
  return _objectSpread({}, colorStyles);
};

var ghostAppearance = function ghostAppearance(props) {
  var colorStyles = getGhostColorStyles(props);
  return _objectSpread({}, colorStyles);
};

var iconAppearance = function iconAppearance(props) {
  return _objectSpread({
    borderRadius: '50%'
  }, getIconColorStyles(props));
};

var outlineAppearance = function outlineAppearance(props) {
  var colorStyles = getOutlineColorStyles(props);
  return _objectSpread({
    borderWidth: 1,
    borderStyle: 'solid'
  }, colorStyles);
};

var appearances = function appearances(props) {
  return {
    ghost: ghostAppearance(props),
    solid: solidAppearance(props),
    outline: outlineAppearance(props),
    icon: iconAppearance(props)
  };
};

var getAppearance = function getAppearance(props) {
  return appearances(props)[props.appearance];
};

var sizes = function sizes() {
  return {
    small: {
      fontSize: 1,
      lineHeight: 1,
      minHeight: '24px',
      paddingX: 2,
      borderRadius: 2
    },
    medium: {
      fontSize: 2,
      lineHeight: 2,
      minHeight: '32px',
      paddingX: 3,
      borderRadius: 4
    },
    large: {
      fontSize: 3,
      lineHeight: 3,
      minHeight: '40px',
      paddingX: 3,
      borderRadius: 4
    }
  };
};

var iconSizes = function iconSizes(props) {
  var iconSizeStyles = {
    small: {
      height: '24px',
      width: '24px'
    },
    medium: {
      height: '32px',
      width: '32px'
    },
    large: {
      height: '40px',
      width: '40px'
    },
    tiny: {
      height: '20px',
      width: '20px'
    }
  };

  if (props.appearance === 'icon') {
    return iconSizeStyles[props.size];
  }
};

var getSize = function getSize(props) {
  return _objectSpread(_objectSpread({}, iconSizes(props)), sizes()[props.size]);
};

var shapeSizes = function shapeSizes() {
  var commonStyle = {
    borderRadius: '50%'
  };
  return {
    round: {
      small: _objectSpread(_objectSpread({}, commonStyle), {}, {
        padding: '4px',
        width: '24px',
        height: '24px'
      }),
      medium: _objectSpread(_objectSpread({}, commonStyle), {}, {
        padding: '6px',
        width: '32px',
        height: '32px'
      }),
      large: _objectSpread(_objectSpread({}, commonStyle), {}, {
        padding: '8px',
        width: '40px',
        height: '40px'
      })
    }
  };
};

var getShape = function getShape(props) {
  var _shapeSizes$props$sha;

  return (_shapeSizes$props$sha = shapeSizes()[props.shape]) === null || _shapeSizes$props$sha === void 0 ? void 0 : _shapeSizes$props$sha[props.size];
}; // base CSS, applied before all others


export var _getBaseStyle = function _getBaseStyle(props) {
  return _objectSpread(_objectSpread(_objectSpread({
    position: 'relative',
    overflow: 'hidden',
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'transparent',
    cursor: 'pointer',
    '&&': {
      cursor: props.disabled && 'not-allowed',
      pointerEvents: props.disabled && 'none'
    }
  }, getSize(props)), getAppearance(props)), getShape(props));
};